<div class="hr-container text-center"><span class="hr-line"></span></div>